import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../config/api.js";
import { Icon } from "../components/Icon.jsx";

// Landing page when a hosted-checkout payment is cancelled or fails. Razorpay sends
// the customer here (cancel_url) or our callback redirects here on a failed/incomplete
// payment. We release the hold immediately so the item frees up (the cart itself is
// preserved so the customer can retry without re-adding anything).
export default function PaymentFailed() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const orderId = params.get("order") || "";
  const idsParam = params.get("ids") || "";
  const released = useRef(false);

  useEffect(() => {
    if (released.current) return;
    released.current = true;
    const ids = (idsParam ? idsParam.split(",") : [orderId]).filter(Boolean);
    if (ids.length) api.releaseStock(ids); // best-effort; frees the held item now
    // Payment failed → the cart stays, but drop the post-payment markers so they don't
    // wrongly clear the cart / remove a Buy-Now item on a LATER successful order.
    try { localStorage.removeItem("bloom_pending_clear_cart"); localStorage.removeItem("bloom_purchased_items"); } catch { /* ignore */ }
  }, [orderId, idsParam]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--offwhite)", padding: "40px 16px", fontFamily: "'Syne',sans-serif" }}>
      <div className="card" style={{ width: "100%", maxWidth: 440, padding: 40, textAlign: "center", background: "var(--white)", borderRadius: 4, boxShadow: "0 10px 44px rgba(57,57,63,0.12)" }}>
        <div style={{ width: 72, height: 72, borderRadius: "50%", background: "var(--red-light)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px", fontSize: 34 }}><Icon n="warning" size={34} inline /></div>
        <h1 style={{ fontSize: 24, margin: "0 0 8px", color: "var(--red,#B42318)" }}>Payment didn’t go through</h1>
        <p style={{ fontSize: 14, color: "var(--ink-soft,rgba(57,57,63,0.6))", lineHeight: 1.6, margin: "0 0 26px" }}>
          No money was taken. Your cart is still saved — you can try again whenever you’re ready.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <button className="btn-pink" style={{ padding: 14, borderRadius: 4, fontSize: 14 }} onClick={() => navigate("/cart")}>Try again →</button>
          <button onClick={() => navigate("/")} style={{ padding: 13, borderRadius: 4, fontSize: 14, fontWeight: 700, background: "transparent", border: "1.5px solid var(--border-mid,rgba(57,57,63,0.18))", color: "var(--ink,#39393F)", cursor: "pointer" }}>Continue shopping</button>
        </div>
      </div>
    </div>
  );
}
